import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useStoryStore } from '../stores/storyStore';

const { FiX } = FiIcons;

const CreateStoryModal = ({ onClose }) => {
  const navigate = useNavigate();
  const { createStory } = useStoryStore();
  const [formData, setFormData] = useState({
    title: '',
    description: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title.trim()) return;

    setIsLoading(true);
    const newStory = createStory(formData.title, formData.description);
    setIsLoading(false);
    onClose();
    navigate(`/editor/${newStory.id}`);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="bg-white rounded-lg p-6 w-full max-w-md"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold font-rubik" style={{ color: '#2b6777' }}>
            Neue Geschichte erstellen
          </h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <SafeIcon icon={FiX} className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="title" className="block text-sm font-medium mb-2 font-rubik" style={{ color: '#2b6777' }}>
              Geschichtentitel *
            </label>
            <input
              id="title"
              name="title"
              type="text"
              required
              value={formData.title}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 font-rubik"
              style={{ color: '#2b6777' }}
              placeholder="Geben Sie den Geschichtentitel ein"
            />
          </div>

          <div>
            <label htmlFor="description" className="block text-sm font-medium mb-2 font-rubik" style={{ color: '#2b6777' }}>
              Beschreibung (Optional)
            </label>
            <textarea
              id="description"
              name="description"
              rows={3}
              value={formData.description}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 font-rubik"
              style={{ color: '#2b6777' }}
              placeholder="Kurze Beschreibung Ihrer Geschichte"
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 transition-colors font-rubik"
              style={{ color: '#2b6777' }}
            >
              Abbrechen
            </button>
            <motion.button
              type="submit"
              disabled={!formData.title.trim() || isLoading}
              className="px-6 py-2 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-white font-rubik"
              style={{ backgroundColor: '#c8d8e4' }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isLoading ? 'Erstellen...' : 'Geschichte erstellen'}
            </motion.button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default CreateStoryModal;